import { PageLocatorMap } from '../types/PageLocatorMap';

export const coapplicantIncomeDetailsPage = {
  alert: {
    error: 'coapplicant-income-details-page.form.alert.error',
  },
  footer: {
    root: 'coapplicant-income-details-page.footer.root',
  },
  form: {
    amountInput: 'coapplicant-income-details-page.form.amount-input',
    amountInputError: 'coapplicant-income-details-page.form.amount-input-error',
    employerNameInput:
      'coapplicant-income-details-page.form.employer-name-input',
    employerNameInputError:
      'coapplicant-income-details-page.form.employer-name-input-error',
    frequencySelect: 'coapplicant-income-details-page.form.frequency-select',
    frequencySelectError:
      'coapplicant-income-details-page.form.frequency-select-error',
    h1: 'coapplicant-income-details-page.form.h1',
    h2: 'coapplicant-income-details-page.form.h2',
    incomeTypeSelect: 'coapplicant-income-details-page.form.income-type-select',
    incomeTypeSelectError:
      'coapplicant-income-details-page.form.income-type-select-error',
    jobTitleInput: 'coapplicant-income-details-page.form.job-title-input',
    jobTitleInputError:
      'coapplicant-income-details-page.form.job-title-input-error',
    monthSelect: 'coapplicant-income-details-page.form.month-select',
    monthSelectError: 'coapplicant-income-details-page.form.month-select-error',
    root: 'coapplicant-income-details-page.form.root',
    submitButton: 'coapplicant-income-details-page.form.submit-button',
    yearSelect: 'coapplicant-income-details-page.form.year-select',
    yearSelectError: 'coapplicant-income-details-page.form.year-select-error',
  },
} as const satisfies PageLocatorMap;
